import { render, staticRenderFns } from "./ModalWarningAdmin.vue?vue&type=template&id=5275fe38&scoped=true"
import script from "./ModalWarningAdmin.vue?vue&type=script&lang=js"
export * from "./ModalWarningAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275fe38",
  null
  
)

export default component.exports